import React,{useState,useEffect} from 'react'
import ProductCard from '../Cards/ProductCard';
import Ex from '../Cards/Ex';
import Collections from '../../Data/Collections';

const ProductsContainer = ({productList}) => {
  const [Products,setProducts]=useState([]);
  console.log("produclist in product conte : "+productList);

  useEffect(() => {
    switch (productList) {
      case "grocceries":
        setProducts(Collections.Grocceries);
        break;
      case "homekitchen":
        setProducts(Collections.HomeKitchen);
        break;
      case "fashion":
        setProducts(Collections.Fashion)
        break;
      default:
        setProducts(Collections.Grocceries);
        break;
    }

  }, [productList])
  

  console.log("data are : ",Products);
  return (
    <div>
      
 <div className='w-full  px-1 lg:px-2 py-2 lg:py-4'>
        <div className='grid grid-cols-2 lg:grid-cols-4 md:grid-cols-4 gap-1 md:gap-2 lg:gap-4'>
         { 
          Products.map((curElem,index)=>{
            return (
              <div key={index} >
              <ProductCard ProductDetails={curElem} />
              </div>
            )
          })
         }
          
        </div>

    </div>

    </div>
  )
}

export default ProductsContainer